import { apiPostWithStatusCode, apiPost } from "./services";
import { GETNEWORDERS, GETPRODUCTURL } from "../api/apiConfig";
import actions from "../store/actions";

export const getNotifications = async (numOfNewOrders, dispatch, navigate) => {
  if (numOfNewOrders >= 0) {
    const response = await apiPostWithStatusCode(GETNEWORDERS, {
      vendor: "The Cricket Store",
    });
    if (response.status === 200) {
      const res = response.data;
      let orderNo = 0;
      if (res.length > 0) {
        const newOrdersArray = res.filter(
          (e) => e.orderStatus === 0 && e.newOrder === true
        );
        orderNo = newOrdersArray.length;
        if (orderNo > numOfNewOrders) {
          dispatch(actions.updateNumOfNewOrders(orderNo));
          navigate("/notifications", { state: { count: orderNo } });
        }
      }
    } else {
      setTimeout(async () => {
        await getNotifications();
      }, 10000);
    }
  }
};

export const getOrderItems = async (id) => {
  const vendor = localStorage.getItem("userName");
  const res = await apiPost(GETNEWORDERS, { vendor: "The Cricket Store" });
  if (res) {
    const currentOrder = res.filter(({ orderId }) => orderId === id);
    console.log("current order", currentOrder);

    const lineItemObject = { ...currentOrder[0] };
    console.log("current order ln item obj", lineItemObject);
    let itemsAndLinks = [];
    const response = await apiPost(GETPRODUCTURL, { orderId: id, vendor });    
    if (response) {
      lineItemObject.lineItems.forEach((item) => {
        const link = response.filter(
          ({ variantTitle }) => variantTitle === item.variantTitle
        );
        
        itemsAndLinks.push({
          ...item,
          ...link[0],
          
        });
      });
    }
   
    return { itemsAndLinks, orderResponse:  lineItemObject};
  }
};
